import { Router, Switch, Route } from 'react-router-dom';
import React from 'react';
import { createMemoryHistory, createBrowserHistory } from 'history';
import ReactRouter from './ReactRouter';

import { browserUrlToReactUrl, reactUrlToBrowserUrl } from '../../urlParse';
import { pushError } from '../../pushError';
import { replaceAllComplex, umcodeURL } from '../../mol_function';

import '..//style/index.scss';

let browserUrl = null;
let apidata = null;
let memoryHistory = null;

try {
  if (window.renderCtrItem != null) {
    browserUrl = window.renderCtrItem.reactUrl;
    apidata = window.renderCtrItem.apidata;
  } else {
    let pathname = window.location.pathname;
    let search = window.location.search;

    browserUrl = browserUrlToReactUrl(pathname, search);
  }

  let initRoute = browserUrl;

  try {
    decodeURI(location.pathname);
  } catch (error) {
    let newUrl = umcodeURL(location.pathname);

    try {
      decodeURI(newUrl);
      window.history.pushState(null, document.title, newUrl);
    } catch (error5) {
      pushError('ReactEnty.UTF8URL', {
        org: location.pathname,
        newUrl: newUrl,
      });
    }
  }

  let browserHistory = createBrowserHistory();
  memoryHistory = createMemoryHistory({ initialEntries: [initRoute] });

  window.historyHelper = {
    browser: browserHistory,
    memory: memoryHistory,
    pushError: pushError,
  };

  browserHistory.listen((lh) => {
    try {
      let react = browserUrlToReactUrl(lh.pathname, lh.search);
      let currentLoc = memoryHistory.location;
      let curentUrl = currentLoc.pathname + currentLoc.search;
      if (curentUrl != react && react != '') {
        //console.log('Broswer Redirect ', curentUrl, ' -> ', react);
        memoryHistory.push(react, null);
      }
    } catch (error4) {
      pushError('browserHistory.listen', error4);
    }
  });

  memoryHistory.listen((lm) => {
    try {
      if (lm.pathname == '/extern') {
        let url = lm.state;
        window.location = url;
      } else {
        let url = reactUrlToBrowserUrl(lm.pathname, lm.search, null);
        let oldUrl =
          browserHistory.location.pathname + browserHistory.location.search;
        if (url != '' && oldUrl != url) {
          window.scrollTo(0, 0);
          //console.log('Frame Redirect ', oldUrl, ' -> ', url);
          browserHistory.push(url, null);
        }
      }
    } catch (error3) {
      pushError('memoryHistory.listen', error3);
    }
  });

  let reactLink = reactUrlToBrowserUrl(initRoute, null, apidata);
  let broserLoc = browserHistory.location;
  let broserUrl = broserLoc.pathname + broserLoc.search;

  if (broserUrl != reactLink) {
    browserHistory.replace(reactLink, null);
  }
} catch (error) {
  pushError('JS-Client Init', error);
}

const ReactEntry = () => {
  try {
    let apidata = null;
    let mode = 'react';

    if (window.renderCtrItem != null) {
      let ctrItem = window.renderCtrItem;
      window.renderCtrItem = null;
      apidata = ctrItem.apidata;
      mode = 'hydrate';
    }

    let renderingUrl = window.location.origin;

    return (
      <div id="App">
        <Router history={memoryHistory}>
          <React.StrictMode>
            <ReactRouter
              apiData={apidata}
              mode={mode}
              renderingUrl={renderingUrl}
            />
          </React.StrictMode>
        </Router>
      </div>
    );
  } catch (error2) {
    pushError('ReactEnty Component', error2);
  }
};

export default ReactEntry;
